export default __webpack_public_path__ + "static/media/Belt of Red Ruin (nm).4590361b.jpg";